module.exports = __webpack_public_path__ + "static/media/equipment_01.073179e7.jpg";